/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ICON_LAUNCH, NavigationItem } from '@squiz/sds';
import { DXP_EXTERNAL_LINKS } from './ExternalLinks.constants';
import { INSTANCE_MANAGEMENT_STRINGS } from './Strings.constants';

/**
 * External link to Datastore user tutorials.
 */
export const DATASTORE_USER_TUTORIALS: NavigationItem = {
  action: (): void => {
    window.open(DXP_EXTERNAL_LINKS.datastoreUserTutorials, '_blank', 'noopener');
  },
  icon: ICON_LAUNCH,
  key: `datastore-user-tutorials`,
  label: INSTANCE_MANAGEMENT_STRINGS.userTutorials,
  path: ``,
};

/**
 * External link to Blueprint CLI docs.
 */
export const DATASTORE_BLUEPRINT_CLI: NavigationItem = {
  action: (): void => {
    window.open(DXP_EXTERNAL_LINKS.datastoreCliServices, '_blank', 'noopener');
  },
  icon: ICON_LAUNCH,
  key: `datastore-blueprint-cli`,
  label: INSTANCE_MANAGEMENT_STRINGS.blueprintCli,
  path: ``,
};

/**
 * External link to Datastore features and capabilities docs.
 */
export const DATASTORE_FEATURES_CAPABILITIES: NavigationItem = {
  action: (): void => {
    window.open(DXP_EXTERNAL_LINKS.datastoreFeaturesAndCapabilities, '_blank', 'noopener');
  },
  icon: ICON_LAUNCH,
  key: `datastore-features-capabilities`,
  label: INSTANCE_MANAGEMENT_STRINGS.featuresAndCapabilities,
  path: ``,
};

/**
 * External link to Blueprint Marketplace.
 */
export const DATASTORE_BLUEPRINT_MARKETPLACE: NavigationItem = {
  action: (): void => {
    window.open(DXP_EXTERNAL_LINKS.datastoreBlueprintMarketplace, '_blank', 'noopener');
  },
  icon: ICON_LAUNCH,
  key: `datastore-blueprint-marketplace`,
  label: INSTANCE_MANAGEMENT_STRINGS.blueprintMarketplace,
  path: ``,
};
